module.exports = __webpack_public_path__ + "img/lighthouse.803e2001.svg";